import React, { useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./Component/Dashboard/Dashboard";
import ListofServices from "./Component/ListOfServices/ListofServices";
import Employee from "./Component/Employee/Employee";
import Rights from "./Component/Rights/Rights";
import Login from "./Component/LoginPage/Login";



const ProtectedRoute = ({ isAuthenticated, children }) => {
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }
    return children;
};

const RoutingFile = () => {
    // Check if user is authenticated
    const initAuth = () => {
        const auth = localStorage.getItem("isAuthenticated");
        // Logic to verify access tokens here
        return auth ? auth : false;
    };
      const [isAuthenticated, setIsAuthenticated] = useState(initAuth());
    // const [isAuthenticated, setIsAuthenticated] = useState(true);

    // Function to handle user login
    const handleLoginset = () => {
        setIsAuthenticated(true);
        localStorage.setItem("isAuthenticated", true);
    };

    // Function to handle user logout
    const handleLogout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem("isAuthenticated");
    };

    return (
        <>
            <Routes>
                <Route path="/" element={<Login handleLoginset={handleLoginset} />} />

                {/* -----------------------Dashboard------------------- */}
                <Route
                    path="/Dashboard"
                    element={
                        <ProtectedRoute isAuthenticated={isAuthenticated}>
                            <Dashboard />
                        </ProtectedRoute>
                    } />
                <Route
                    path="/ListOfService"
                    element={
                        <ProtectedRoute isAuthenticated={isAuthenticated}>
                            <ListofServices/>
                        </ProtectedRoute>
                    } />
                    <Route
                    path="/Employee"
                    element={
                        <ProtectedRoute isAuthenticated={isAuthenticated}>
                            <Employee/>
                        </ProtectedRoute>
                    } />
                    <Route
                    path="/Employee/RightsAndPermissions/:username"
                    element={
                        <ProtectedRoute isAuthenticated={isAuthenticated}>
                            <Rights/>
                        </ProtectedRoute>
                    } />

            


            </Routes>
        </>
    )
}

export default RoutingFile
